export const hasPermission = (userPermissions, permission) => {
    return userPermissions.includes(permission)
}
export const hasModulePermission = (userPermissions, modulePermissions) => {
    return modulePermissions.filter(permission => userPermissions.includes(permission)).length > 0 
}